import 'react-toggle/style.css';
import styled from 'styled-components';

import { faCaretSquareDown, faCaretSquareUp } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import useDataSorter from 'src/CustomHooks/useDataSorter';
import IIntersystemsComponent from 'src/ServerEntities/IIntersystemsComponent';

const Table = styled.table`
    width: 100%;
`;

const ItemLine = styled.tr`
    display: flex;
    flex-direction: row;
    flex: 1 0 auto;
    width: 100%;
    justify-content: space-between;
`;

export const ItemCell = styled.td`
    text-align: center;
    padding: 5px;
    font-size: 1em;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.error  {
        color: #F00;
    }
`;

const OuterContainer = styled.div`
    border-radius: 25px;
    border: 5px solid #44A2D6;
    padding: 2px;
    flex: 1 1 auto;
`;

const InnerContainer = styled.div`
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
`;

const TitleBar = styled.div`
    border-radius: 20px;
    background-color: #1577AE;
    padding: 5px;
    color: #FFF;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
`;

const StateBubble = styled.div`
    border-radius: 15px;
    padding: 1px;
    padding-bottom: 2px;
    text-align: center;
    font-size: 0.8em;
    font-weight: bold;
    &.ERROR  {
        background-color: #F00;
        color: #FFF;
    }
    &.DISABLED  {
        background-color: #B7BEC2;
        color: #000;
    }
    &.OK  {
        background-color: #5CEA5A;
        color: #FFF;
    }
    &.RETRY  {
        background-color: #2DF6C0;
        color: #FFF;
    }
`;

const ItemHeaderCell = styled.td`
    text-align: center;
    padding: 0.1em;
    font-size: 0.9em;
    font-weight: bold;
    color: #1577AE;
`;

interface IProps {
    data: IIntersystemsComponent[]
};

export const renderState = (state: string) => {
    const stateUpper = state.toLocaleUpperCase();
    switch (stateUpper) {
        case "ERROR": return <StateBubble className={stateUpper}>Errored</StateBubble>
        case "DISABLED": return <StateBubble className={stateUpper}>Disabled</StateBubble>
        case "STOPPED": return <StateBubble className={stateUpper}>Stopped</StateBubble>
        case "INACTIVE": return <StateBubble className={stateUpper}>Inactive</StateBubble>
        case "RUNNING": return <StateBubble className={stateUpper}>Running</StateBubble>
        case "OK": return <StateBubble className={stateUpper}>Running</StateBubble>
        case "RETRYING": return <StateBubble className={stateUpper}>Retrying</StateBubble>
        case "RETRY": return <StateBubble className={stateUpper}>Retrying</StateBubble>
    }
    return null;
};

const serviceToItem = (array: [string, string, number, number], index: number) => {
    return <ItemLine key={`intersystems-service-${index}-${[array[0]]}`}>
        <ItemCell width={"50%"} style={{ textAlign: "left" }} className={array[1] === "ERROR" ? "error" : ""} title={array[0]}>{array[0]}</ItemCell>
        <ItemCell width={"25%"}>{renderState(array[1])}</ItemCell>
        <ItemCell width={"25%"}>{array[2]}</ItemCell>
    </ItemLine>
};

const IntersystemsServices = (props: IProps) => {
    const { data } = props;
    const [sortByColumn, setSortByColumn] = React.useState(4);
    const [sortDescending, setSortDescending] = React.useState(true);

    const changeSortColumn = (columnIndex: number) => (event: React.SyntheticEvent) => {
        event.stopPropagation();
        if (columnIndex === sortByColumn) {
            setSortDescending(!sortDescending);
        } else {
            setSortDescending(true);
        }
        setSortByColumn(columnIndex);
    };

    const routeToArray = (route: IIntersystemsComponent, index: number): [string, string, number, number] => [
        route.name,
        route.state,
        route.alerts,
        index,
    ];

    const sortedData = data.map(routeToArray).sort(useDataSorter(sortByColumn, sortDescending))

    const renderSort = () => {
        return sortDescending ? <FontAwesomeIcon icon={faCaretSquareUp} style={{ marginRight: "8px" }} /> : <FontAwesomeIcon icon={faCaretSquareDown} style={{ marginRight: "8px" }} />
    }

    return <OuterContainer>
        <TitleBar>Services</TitleBar>
        <InnerContainer>
            <Table>
                <thead>
                    <ItemLine>
                        <ItemHeaderCell width={"50%"}></ItemHeaderCell>
                        <ItemHeaderCell width={"25%"}></ItemHeaderCell>
                        <ItemHeaderCell width={"25%"} onClick={changeSortColumn(2)}>Alerts {renderSort()}</ItemHeaderCell>
                    </ItemLine>
                </thead>
                <tbody>
                    {sortedData.map(serviceToItem)}
                </tbody> 
            </Table>
        </InnerContainer>
    </OuterContainer>;
};

export default IntersystemsServices;
